import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Link, useStyleConfig } from '@chakra-ui/react'
import { Link as LinkRouter, useLocation, useNavigate } from 'react-router-dom'
import UnderLine from '../UnderLine/UnderLine'

function CustomLink(props) {
  const {
    variant,
    disableUnderLine,
    to,
    children,
    onClick: onClickHeader,
    ...rest
  } = props
  const styles = useStyleConfig('Link', { variant })
  const loc = useLocation()
  const navigate = useNavigate()
  const onClick = () => {
    onClickHeader?.()
    if (loc.pathname === to) {
      location.reload()
    } else {
      navigate(to)
    }
  }
  return (
    <Flex
      h="100%"
      direction="column"
      alignItems="center"
      justifyContent="center"
      position="relative"
    >
      <Link
        onClick={onClick}
        to={to}
        sx={{ ...styles }}
        as={LinkRouter}
        {...rest}
      >
        {children}
      </Link>
      {!disableUnderLine && (
        <Box position="absolute" bottom="-6px" left={-1}>
          {loc.pathname === to && <UnderLine />}
        </Box>
      )}
    </Flex>
  )
}

CustomLink.propTypes = {
  children: PropTypes.node,
  clicked: PropTypes.bool,
  disableUnderLine: PropTypes.bool,
  onClick: PropTypes.func,
  to: PropTypes.string,
  variant: PropTypes.string,
}

export default CustomLink
